import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import { ThemeContext } from 'styled-components'

import HowToBlock from 'components/_special/HowToBlock'
import HowToOrderMobile from 'components/_special/HowToOrderMobile'
import SectionWrapper from 'components/SectionWrapper'
import { RU } from 'constants/countries'
import { LocalizationContext } from 'contexts/Localization'
import { ResizeContext } from 'contexts/Resize'

import DHowOrderEuroBox from './components/DHowOrderEuroBox'
import DHowOrderRussianBox from './components/DHowOrderRussianBox'

const MOBILE_IMAGES_EU = ['instruction', 'brochure', 'container', 'box']

const MOBILE_IMAGES_RU = [
  'slider-instruction-new',
  'slider-test-tube-new',
  'slider-bag-new',
]

/**
 * DHowOrder
 *
 * @param {object} props - properties of component
 * @returns {node} DHowOrder
 */
const DHowOrder = props => {
  const { data, pathCdn, index, isSquareHidden } = props
  const { mobile } = useContext(ResizeContext)
  const { paths, locale } = useContext(LocalizationContext)
  const { colors } = useContext(ThemeContext)

  return (
    <SectionWrapper isOverflowHidden={true}>
      {mobile ? (
        <HowToOrderMobile
          {...{ pathCdn, index }}
          descriptions={data.slider.list}
          images={locale === RU ? MOBILE_IMAGES_RU : MOBILE_IMAGES_EU}
          title={data.title}
          squareColor={colors.grass}
        />
      ) : (
        <HowToBlock
          {...{ index, isSquareHidden }}
          title={data.title}
          isFirst={true}
          squareColor={colors.grass}
        >
          {locale === RU ? (
            <DHowOrderRussianBox
              {...{ path: `${paths.cdn_global}/boxes`, data }}
            />
          ) : (
            <DHowOrderEuroBox
              {...{ path: `${paths.cdn_global}/boxes`, data }}
            />
          )}
        </HowToBlock>
      )}
    </SectionWrapper>
  )
}

DHowOrder.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  pathCdn: PropTypes.string.isRequired,
  isSquareHidden: PropTypes.bool,
}

DHowOrder.defaultProps = {
  isSquareHidden: false,
}

export default DHowOrder
